import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { VideoDialogComponent } from './video-dialog/video-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MousePressDirective } from '@app/shared/directives/mouse-press.directive';

@Component({
    selector: 'tc-video-guide',
    templateUrl: './video-guide.component.html',
    styleUrls: ['./video-guide.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [
        TranslateModule,
        MatDialogModule,
        MatButtonModule,
        MousePressDirective
    ]
})
export class VideoGuideComponent {
    @Input() url: string;
    @Input() isButton: boolean = false;
    @Input() linkToUrl: boolean = false;
    @Input() poster: string;

    constructor(public dialog: MatDialog) { }

    openVideo(): void {
        if (this.linkToUrl) {
            window.open(this.url, '_blank');
        } else {
            const dialogRef = this.dialog.open(VideoDialogComponent, {
                data: {
                    url: this.url,
                    poster: this.poster
                },
                panelClass: 'mat-video-guide-dialog'
            });
        }
    }
}